export default "__VITE_ASSET__B7QGf41Y__"